export enum EventType {
    HouseParty = "HOUSE_PARTY",
    Hotel = "HOTEL",
    Club = "CLUB",
    Outdoors = "OUTDOORS",
}